// extracted by mini-css-extract-plugin
export default {"iconLink":"FaPortalLinkIcon_iconLink__Slr-6","iconInner":"FaPortalLinkIcon_iconInner__jfL28","faIcon":"FaPortalLinkIcon_faIcon__926rY"};